import { render, staticRenderFns } from "./VerSucursal.vue?vue&type=template&id=c8fd3458&"
import script from "./VerSucursal.vue?vue&type=script&lang=js&"
export * from "./VerSucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports